// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.favouritesMain {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: calc(100vh - 92px);
    gap: 55px;
    align-items: left;
    justify-content: left;
    padding: 40px 15px 0 15px;
}

.favouritesEmptyText {
    color: #8E3B00;
    font-size: 19.27px;
    font-weight: 700;
    line-height: 23.12px;
    text-align: left;
    -webkit-user-select: none;
            user-select: none;
    width: 70%;
}

.favouritesEmptyImage {
    width: 246px;
    height: 394px;
}

.favourotesEmptyColumn {
    display: flex;
    flex-direction: column;
    gap: 80px;
    width: 100%;
    height: calc(100vh - 202px);
    align-items: center;
    justify-content: flex-end;
}

.favouritesColumn {
    display: flex;
    flex-direction: column;
    gap: 40px;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Favourites/Favourites.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf","sourcesContent":[".favouritesMain {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    min-height: calc(100vh - 92px);\n    gap: 55px;\n    align-items: left;\n    justify-content: left;\n    padding: 40px 15px 0 15px;\n}\n\n.favouritesEmptyText {\n    color: #8E3B00;\n    font-size: 19.27px;\n    font-weight: 700;\n    line-height: 23.12px;\n    text-align: left;\n    user-select: none;\n    width: 70%;\n}\n\n.favouritesEmptyImage {\n    width: 246px;\n    height: 394px;\n}\n\n.favourotesEmptyColumn {\n    display: flex;\n    flex-direction: column;\n    gap: 80px;\n    width: 100%;\n    height: calc(100vh - 202px);\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.favouritesColumn {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
